<app-modal>
    <form class="form">
        <div class="form_group">
            <label class="row inp_group row_ai_center">
                <div class="col-5 lbl lbl_mb_0">Имя</div>
                <div class="row row_inp col-19">
                    <input type="text" [(ngModel)]="customerForm.firstname" name="firstname" class="inp" placeholder="John">
                    <input type="text" [(ngModel)]="customerForm.lastname" name="lastname" class="inp" placeholder="Doe">
                </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-5 lbl lbl_mb_0">Телефон</div>
                <div class="col-19">
                    <app-input-tel name="phone" [phoneValue]="customerForm.phone" (phoneValueChange)="customerForm.phone = $event"></app-input-tel>
                    </div>
            </label>
            <label class="row inp_group row_ai_center">
                <div class="col-5 lbl lbl_mb_0">Имейл</div>
                <div class="col-19"><input type="email" [(ngModel)]="customerForm.email" name="email" class="inp"
                        placeholder="example@example.com"></div>
            </label>
        </div>
        <div class="btns_container row fw_500 fz_s">
            <button (click)="closeModal()" class="btn btn_cancel">Отмена</button>
            <button (click)="createCustomer()" [disabled]="isLoadingSend" class="btn dark_btn row btn_loading_state"><span *ngIf="isLoadingSend" class="loader"></span> <span *ngIf="!isLoadingSend">Создать</span> </button>
        </div>
    </form>
</app-modal>